import { gql } from "@apollo/client";

export const GET_RECEIPT_DETAIL_WITH_TRANSACTION = gql`
  query receiptDetailWithTransaction($transactionId: ID!) {
    receiptDetailWithTransaction(transactionId: $transactionId) {
      id
      companyName
      units {
        name
        description
        price
        quantity
        productUrl
      }
    }
  }
`;
